'use client';

import { PageSize } from '@dealerportal/common';
import { useCatalogContext } from '../../Contexts/CatalogContext';
import { Paginator } from './Paginator';

type Props = {
  initialPage: number;
};

export const SRPPaginator = ({ initialPage }: Props) => {
  const { products } = useCatalogContext();
  return (
    <div id="pagination" className="srp__pagination ui-mt-6">
      <Paginator
        onPageChange={({ selected }) => {
          const searchParams = new URLSearchParams(window.location.search);
          if (selected === 0) {
            searchParams.delete('page');
          } else {
            searchParams.set('page', (selected + 1).toString());
          }
          window.location.search = searchParams.toString();
        }}
        initialPage={initialPage}
        totalCount={products?.length ?? 0}
        pageSize={PageSize}
      />
    </div>
  );
};
